export default __webpack_public_path__ + "static/media/ic-printer-black.a0a1d780.svg";